export enum Triggers {
  hover = 'hover',
  click = 'click'
}
